import React from 'react';
import { useHistory } from 'react-router-dom';
import './ButtonStyle.css';

const ButtonComman = ({ className, title, arrowIcon, navigateTo, scrollToId }) => {
  const history = useHistory();

  const handleClick = () => {
    if (scrollToId) {
      const element = document.getElementById(scrollToId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else if (navigateTo) {
      history.push(navigateTo);
    }
  };

  return (
    <button className={className} onClick={handleClick}>
      {title}
      {arrowIcon}
    </button>
  );
};

export default ButtonComman;
